import { RENDER_EFFECT } from '../../common/constants';
const EFFECTS = Object.values(RENDER_EFFECT);
export const isRenderEffects = (t) => {
    if (typeof t !== 'string') {
        return false;
    }
    return EFFECTS.some(effect => effect === t);
};
export const isMediaStreamVideoTrack = (t) => t.kind === 'video';
export function assertMediaStreamVideoTrack(t) {
    if (!isMediaStreamVideoTrack(t)) {
        throw new TypeError('Not a video track', { cause: t });
    }
}
//# sourceMappingURL=typeGuards.js.map